import React from "react";
import { Autocomplete, Button, DateRange, Field, SearchField, Filter } from "components/commons";
import { Products } from "enums";
import locale from "localization";
import { prettifyProduct } from "utils/pretty.utils";
import styles from "./buy-fuel-filter.module.scss";

const BuyFuelFilter = ({
  filterState,
  applyFilter,
  applyClearFilter,
  modifyFilter,
  modifySearch,
  applySearch,
  applyClearSearch,
  searchKey,
  filterCount,
  resetFilter,
  exportReport,
  exporting,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.filter}>
        <Filter
          clear={applyClearFilter}
          submit={applyFilter}
          filterCount={filterCount}
          close={resetFilter}
        >
          <Field
            labelPosition={"left"}
            className={styles.date}
            childrenClassName={styles.fieldContent}
            label={locale.purchasedDate}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(name, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({
                  startDate,
                  endDate,
                });
              }}
            />
          </Field>
          <Field
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            className={styles.fieldSelect}
            label={locale.product}
          >
            <Autocomplete
              name="productCode"
              value={filterState.productCode}
              options={[
                { label: locale.all, value: "all" },
                { label: prettifyProduct(Products.Diesel), value: Products.Diesel },
                { label: prettifyProduct(Products.Gas91), value: Products.Gas91 },
                { label: prettifyProduct(Products.Gas95), value: Products.Gas95 },
                { label: prettifyProduct(Products.Gas97), value: Products.Gas97 },
              ]}
              onChange={(name, { value }) => modifyFilter({ [name]: value })}
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchField
            restrict={false}
            placeholder={locale.buyFuelIdAndBusinessName}
            value={searchKey}
            onChange={(_, { value }) => modifySearch(value)}
            onEnter={applySearch}
            onClear={applyClearSearch}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            startIcon={<span className="icon-download" />}
            exportButton
            onClick={exportReport}
            loading={exporting}
          >
            {locale.export}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default BuyFuelFilter;
